import Axios from "../../Config/API";

import {
    IEnviarMensagem,
    IEnviarMensagemAtiva,
    ITransferirMensagem,
} from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import { IContatos } from "../../../Interfaces/Geral/Contatos/ContatosInterfaces";
import Service from "../../Service";

export async function EnviarMensagemService(mensagem: IEnviarMensagem) {
    const data = new FormData();
    if (mensagem.File) {
        data.append("File", mensagem.File);
        data.append("FileName", mensagem.File.name);
        data.append("strContentTypeArquivo", mensagem.File.type);
    }
    data.append("numOrigem", mensagem.numOrigem);
    data.append("numDestino", mensagem.numDestino);
    data.append("strMensagem", mensagem.strMensagem);

    const response = await Axios.post(`/helpdesk/twilio/enviarmensagem`, data)
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function EnviarMensagemAtivaServices(
    mensagem: IEnviarMensagemAtiva,
    flGravacaoFirebase: boolean
) {
    return Service(
        Axios.post(`/helpdesk/twilio/EnviarMensagemAtiva?flGravacaoFirebase=${flGravacaoFirebase ?? false}`, mensagem)
    );
}

export async function TransferirAtendimentoService(
    IdEquipeTransferencia: number,
    IDUsuarioTransferencia: number,
    transferencia: ITransferirMensagem
) {
    return Service(
        Axios.post(
            `/helpdesk/helpdeskcapys/transferiratendimento?IdEquipeTransferencia=${IdEquipeTransferencia}&IDUsuarioTransferencia=${IDUsuarioTransferencia}`,
            transferencia
        )
    );
}

export async function VincularContatoService(tel: string, contato: IContatos) {
    const telToQueryString = tel.replace("+", "%2B");
    return Service(
        Axios.post(
            `/helpdesk/helpdeskcapys/inserirtelefonecontato?telefone=${telToQueryString}`,
            contato
        )
    );
}

export async function FinalizarAtendimentoService(numeroCliente: string) {
    const telToQueryString = numeroCliente.replace("+", "%2B");
    return Service(
        Axios.post(
            `/helpdesk/helpdeskcapys/finalizaratendimento?numeroCliente=${telToQueryString}`
        )
    );
}

export async function ListarTelefoneContatoService(cpfOuEmail: string) {
    return Service(
        Axios.get(
            `/helpdesk/helpdeskcapys/listartelefonecontato?cpfOuEmail=${cpfOuEmail}`
        )
    );
}

export async function DesvincularTelefoneContatoService(
    telefone: string,
    idContato: number,
    idContatoTelefone: number
) {
    const telToQueryString = telefone.replace("+", "%2B");
    return Service(
        Axios.delete(
            `/helpdesk/helpdeskcapys/desvinculartelefonecontato?telefone=${telToQueryString}&idContato=${idContato}&idContatoTelefone=${idContatoTelefone}`
        )
    );
}
